import { ICustomPageResponse } from "models/response/custom-page-response";

export type CustomPageState = {
    customPage: ICustomPageResponse | undefined;
    loading: boolean;
    error: string | undefined;
};

export enum ACTION_TYPES {
    loadCustomPageRequest = 'loadCustomPageRequest',
    loadCustomPageSuccess = 'loadCustomPageSuccess',
    loadCustomPageFailure = 'loadCustomPageFailure',
    clearCustomPage = 'clearCustomPage',
}

export const CustomPageReducer = (state: CustomPageState, action: any): CustomPageState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.loadCustomPageRequest:
            return {
                ...state,
                loading: true,
                error: undefined,
            };
        case ACTION_TYPES.loadCustomPageSuccess:
            return {
                ...state,
                customPage: payload,
                loading: false,
                error: undefined,
            };
        case ACTION_TYPES.loadCustomPageFailure:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case ACTION_TYPES.clearCustomPage:
            return {
                customPage: undefined,
                loading: false,
                error: undefined,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
